export default {
  box: {
    maximize: 'Maximize',
    minimize: 'Minimize'
  }
}
